import { useGlossaryQuery } from '@/hooks/query-hooks';
import { Autocomplete, TextField } from '@mui/material';

export const GlossaryTermAutocomplete = (props: { selectedGlossaryTermId?: string; setGlossaryTermId: (glossaryTermId?: string) => void }) => {
  const { glossaryTerms } = useGlossaryQuery();
  const { selectedGlossaryTermId, setGlossaryTermId } = props;

  return (
    <Autocomplete
      autoHighlight
      id="tags-outlined"
      defaultValue={glossaryTerms?.find((gt) => gt.id === selectedGlossaryTermId)}
      onChange={(event, glossaryTerm) => {
        if (glossaryTerm) setGlossaryTermId(glossaryTerm.id);
        else setGlossaryTermId(undefined);
      }}
      options={glossaryTerms ?? []}
      getOptionLabel={(option) => option.name}
      filterSelectedOptions
      sx={{ minWidth: 200, paddingTop: 1 }}
      renderInput={(params) => <TextField variant="outlined" {...params} label={`Glossary Term`} placeholder={selectedGlossaryTermId ? `Select Glossary Term` : undefined} />}
    />
  );
};
